export const countrySelector = ({
  country
}) => country;
export const isInANZSelector = state => {
  const country = countrySelector(state);
  return country === 'australia' || country === 'new zealand';
};
export const isInUnitedStatesSelector = state => {
  const country = countrySelector(state);

  if (country) {
    return country.toLowerCase() === 'united states';
  }

  return false;
};